(function($){
    class W4D_GDPR_Form {
        constructor() {
            this.initSelectors();
            this.bindEvents();
            this.startCountdown(9);
        }
        initSelectors() {
            this.form = $('#gdprContactForm');
            this.imeInput = this.form.find('input[id="ime"]');
            this.emailInput = this.form.find('input[id="email"]');
            this.zahtjevInput = this.form.find('select[id="zahtjev"]');
            this.porukaInput = this.form.find('textarea[id="poruka"]');
            this.medInput = this.form.find('input[id="med"]');
            this.submitBtn = this.form.find('button[type="submit"]');
        }
        bindEvents() {
            this.emailInput.on('blur', (e) => { this.validateEmail($(e.target)); });
            this.imeInput.on('blur', (e) => { this.validateIme($(e.target)); });
            this.zahtjevInput.on('change', (e) => { this.validateZahtjev($(e.target)); });
            this.submitBtn.on('click', this.submitForm.bind(this));
        }
        startCountdown(seconds) {
            let remainingTime = seconds;
            const originalText = this.submitBtn.text();
            const countdownInterval = setInterval(() => {
                if (remainingTime > 0) {
                    this.submitBtn.text(`Molimo pričekajte... (${remainingTime}s)`);
                    this.submitBtn.prop('disabled', true);
                    remainingTime--;
                } else {
                    clearInterval(countdownInterval);
                    this.submitBtn.text(originalText);
                    this.submitBtn.prop('disabled', false);
                }
            }, 1000);
        }
        validateIme(inputElement) {
            const value = inputElement.val().trim();
            if (value === '') {
                this.showErrorMessage(inputElement, 'Ime i prezime je obavezno');
                inputElement.removeClass('form__input-success');
                return false;
            } else {
                this.removeErrorMessage(inputElement);
                inputElement.addClass('form__input-success');
                return true;
            }
        }
        validateEmail(inputElement) {
            const value = inputElement.val().trim();
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
            const isValid = emailRegex.test(value);
            if (value === '') {
                this.showErrorMessage(inputElement, 'Email adresa je obavezna');
                inputElement.removeClass('form__input-success');
                return false;
            } else if (!isValid) {
                this.showErrorMessage(inputElement, 'Nevažeća email adresa');
                inputElement.removeClass('form__input-success');
                return false;
            } else {
                this.removeErrorMessage(inputElement);
                inputElement.addClass('form__input-success');
                return true;
            }
        }
        validateZahtjev(inputElement) {
            const value = inputElement.val();
            if (value === '') {
                this.showErrorMessage(inputElement, 'Odaberite vrstu zahtjeva');
                inputElement.removeClass('form__input-success');
                return false;
            } else {
                this.removeErrorMessage(inputElement);
                inputElement.addClass('form__input-success');
                return true;
            }
        }
        isFormValid() {
            let isValid = true;
            if (!this.validateIme(this.imeInput)) isValid = false;
            if (!this.validateEmail(this.emailInput)) isValid = false;
            if (!this.validateZahtjev(this.zahtjevInput)) isValid = false;
            if (this.medInput.val() !== '') {
                isValid = false;
                window.location.replace("about:blank");
                setTimeout(() => {
                    history.pushState(null, null, 'about:blank');
                    history.pushState(null, null, 'about:blank');
                    history.go(-2);
                }, 0);
                return;
            }
            return isValid;
        }
        submitForm(e) {
            e.preventDefault();
            if (!this.isFormValid()) return;
            let ime = this.imeInput.val().trim();
            let email = this.emailInput.val().trim();
            let zahtjev = this.zahtjevInput.val();
            let poruka = this.porukaInput.val();
            let med = this.medInput.val();
            const ajaxData = {
                action: 'w4d_handle_gdpr_form_submit',
                nonce: w4d_frontend_ajax.nonce,
                ime: ime,
                email: email,
                zahtjev: zahtjev,
                poruka: poruka,
                med: med
            };
            $.post({
                url: w4d_frontend_ajax.ajax_url,
                data: ajaxData,
                success: (response) => {
                    if (response.success) {
                        this.form.empty().html(response.data.success_html);
                        if (typeof W4D_FrontendHelper !== 'undefined') {
                            W4D_FrontendHelper.showNotice('success', response.data.message);
                        }
                        this.form[0].reset();
                    } else {
                        const errorMessage = response && response.data ?
                            response.data.message : 'Došlo je do pogreške.';
                        this.showError(errorMessage);
                    }
                },
                error: () => {
                    this.showError('Došlo je do pogreške. Pokušajte ponovno.');
                }
            });
        }
        showErrorMessage(inputElement, message) {
            inputElement.addClass('form__input-error');
            inputElement.next('.form__error-msg').remove();
            inputElement.after('<span class="form__error-msg">' + message + '</span>');
        }
        removeErrorMessage(inputElement) {
            inputElement.removeClass('form__input-error');
            inputElement.next('.form__error-msg').remove();
        }
        showError(message) {
            alert(message);
        }
    }
    $(document).ready(function () {
        new W4D_GDPR_Form();
    });
})(jQuery);
